module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.7781/img/screenshot-twitter.png"